<template>
	<!-- 历史开奖 -->
	<div class="historyLottery">
		<!-- 导航 选择彩种-下拉框-->
		<div class="history_lottery_nav">
			<el-row type="flex" justify="start" align="middle">
				<div class="nav-label">选择彩种:</div>
				<el-select v-model="selectedType" placeholder="请选择">
					<el-option v-for="(item, index) in navAry" :key="item.NvgName" :label="item.NvgName" :value="index" />
				</el-select>
				<el-select v-model="selectedGame" placeholder="请选择">
					<el-option
						v-for="item in navAry[selectedType] && navAry[selectedType].LotteryList"
						:disabled="false"
						:key="item.Name"
						:label="item.Name"
						:value="item.LgId"
					/>
				</el-select>
			</el-row>
		</div>
		<!-- 选项卡 -->
		<div class="history_lottery_bar">
			<el-button :type="type === 0 ? 'primary' : 'text'" @click="type = 0">最近30期开奖数据</el-button>
			<el-button :type="type === 1 ? 'primary' : 'text'" @click="type = 1">最近50期开奖数据</el-button>
			<el-button :type="type === 2 ? 'primary' : 'text'" @click="type = 2">最近100期开奖数据</el-button>
			<el-button :type="type === 3 ? 'primary' : 'text'" @click="type = 3">今日数据</el-button>
		</div>
		<!-- 表格 -->
		<div class="history_lottery_table">
			<table cellspacing="0" cellpadding="0">
				<thead>
					<tr class="table_th_text">
						<th>期号</th>
						<th>开奖时间</th>
						<th>开奖号码</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in ary" :key="index">
						<td>{{ item.FormatLssue }}</td>
						<td>{{ item.OpenTime }}</td>
						<td class="history_lottery_gift">
							<div class="box_h lottery_number">
								<div
									v-for="(value, num) in item.OpenNumber"
									:key="num"
									:class="`text_${isNaN(value) ? 'symbol' : 'number'}`"
								>
									{{ value }}
								</div>
							</div>
						</td>
					</tr>
					<tr v-if="ary.length === 0" style="height: 200px">
						<td colspan="3">暂无记录!</td>
					</tr>
				</tbody>
			</table>
		</div>
	</div>
</template>
<script>
import { postAjax, getAjax } from "../../util/ajax.js";
import { SysKey } from "../../util/sysconfig";

export default {
	data() {
		return {
			url: SysKey("ImgServerUrl").SysValue, //图片地址
			LgId: Number(this.$route.query.id), //游戏ID
			ary: [], //历史记录,
			navAry: [], //导航栏数据,
			type: Number(this.$route.query.type) || 0, //当前请求数据的时间范围类型,
			navText: "", //导航栏显示标题
			selectedType: "请选择", // 下拉菜单选中彩票类; 值是数组下标
			selectedGame: "请选择", // 下拉菜单选中彩票游戏; 值是LgId
		};
	},
	methods: {
		// 获取数据
		getList() {
			if (this.type !== Number(this.$route.query.type) || this.LgId !== Number(this.$route.query.id)) {
				this.$router.replace({
					path: "/history",
					query: { id: this.LgId, type: this.type },
				});
			}
			let that = this;
			let url = "api/Lssue/GetLssueOpenHistory?lgId=" + that.LgId + "&type=" + that.type;
			let load = this.$loading({
				lock: true,
				text: "加载中...",
				spinner: "el-icon-loading",
				background: "rgba(0,0,0,0)",
				customClass: "all_vue_loading",
			});
			postAjax(url)
				.then(function (data) {
					if (data.IsSucess) {
						that.ary = data.Data;
						load.close(); //关闭加载层
					} else {
						load.close(); //关闭加载层
					}
				})
				.then(function () {
					that.ary.forEach(item => {
						// 带+=符号的开奖号码
						let textSymbol = [18, 19, 20, 37];
						if (textSymbol.includes(that.LgId)) {
							item.OpenNumber = item.OpenNumber.split("=")[0]
								.split("")
								.concat(["="].concat(item.OpenNumber.split("=")[1]));
						} else {
							item.OpenNumber = item.OpenNumber.split(",");
						}
					});
				});
		},
		// 获取导航数据
		navList() {
			let that = this;
			let url = "Api/Lnc/Get";
			getAjax(url).then(function (data) {
				that.navAry = data.Data.filter(item => item.LotteryList.length > 0);
			});
		},
	},
	created() {
		this.getList();
		this.navList();
	},
	watch: {
		// 一级选框变更时,更改二级选框的内容
		selectedType: function () {
			this.selectedGame = "请选择";
		},
		// 二级选框变更时,变更地址栏和请求新的历史数据
		selectedGame: function () {
			if (!isNaN(this.selectedGame) && this.selectedGame !== this.LgId) {
				this.LgId = this.selectedGame; // 更改LgId,之后发起请求
			}
		},
		type: function () {
			this.getList();
		},
		LgId: function () {
			this.getList();
		},
		navText: function () {
			$("title").html(this.navText + "历史开奖");
		},
		navAry: function () {
			let that = this;
			// 选中一级选框当前项 和 二级选框当前项
			that.navAry.forEach((item, index) => {
				item.LotteryList.forEach((e, index2) => {
					if (e.LgId === that.LgId) {
						that.selectedType = index; // 一级选框当前项
						that.$nextTick(() => (that.selectedGame = e.LgId)); // 二级选框当前项
					}
				});
			});
		},
	},
};
</script>
<style>
.historyLottery {
	width: 1200px;
	margin: auto;
}

/* 选择彩种-下拉框 */
.history_lottery_nav {
	padding-top: 30px;
}

.history_lottery_nav .nav-label {
	font-size: 14px;
	font-weight: bold;
	color: #333333;
}

.history_lottery_nav .el-select {
	margin-left: 20px;
}

/* 选项卡 */
.history_lottery_bar {
	padding: 20px 0;
}

/* 表格 */
.history_lottery_table {
	min-height: 600px;
	padding: 0 0 20px;
	overflow: hidden;
	text-align: center;
	background-color: white;
}

.history_lottery_table table {
	width: 100%;
	border-right: 1px solid #c6d1d0;
	border-bottom: 1px solid #c6d1d0;
}

.history_lottery_table table td,
.history_lottery_table table th {
	border-top: 1px solid #c6d1d0;
	border-left: 1px solid #c6d1d0;
}

.history_lottery_table .table_th_text > th {
	font-size: 18px;
	font-weight: normal;
	color: #111311;
	padding: 17px 0;
}

.history_lottery_table .table_th_text {
	background-color: #ccdfe4;
	overflow: hidden;
}

.history_lottery_table tbody > tr {
	background-color: #fff;
}

.history_lottery_table tbody > tr:nth-child(even) {
	background-color: #e8f3f6;
}

.history_lottery_table tbody > tr:hover {
	background-color: #e8f3f6;
}

.history_lottery_table tbody > tr > td {
	line-height: 60px;
	color: #424242;
	font-style: normal;
	font-size: 14px;
}

.history_lottery_table .history_lottery_gift .lottery_number {
	align-items: center;
	justify-content: center;
}

.history_lottery_table .history_lottery_gift .lottery_number .text_symbol {
	font-size: 32px;
	color: #0e78c7;
}

.history_lottery_table .history_lottery_gift .lottery_number .text_number {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 40px;
	height: 40px;
	margin: 0 4px;
	border-radius: 40px;
	background-color: #1483d1;
	font-size: 16px;
	font-weight: bold;
	color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/mainPage/historyLottery.vue